import { Link } from "react-router-dom";
import { ArrowUpRight, Play, Clock, Cpu } from "lucide-react";
import { useT } from "../i18n";

const VIDEO_ID = "WYwoh_nmVlQ";

export const Video = () => {
    const { t } = useT();

    return (
        <main data-testid="video-page" className="bg-white text-[#0E1A2B]">
            <section className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-20 pb-12">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
                    <div className="md:col-span-8">
                        <p className="font-mono text-xs uppercase tracking-[0.22em] text-[#0033A0] mb-4">
                            {t("video.tag")}
                        </p>
                        <h1 className="font-display text-5xl md:text-7xl leading-[1.02] tracking-tight text-[#0033A0]">
                            {t("video.heading")}
                        </h1>
                        <p className="mt-5 font-display italic text-xl md:text-2xl text-[#0033A0] max-w-xl">
                            {t("video.sub")}
                        </p>
                    </div>
                    <div className="md:col-span-4 md:col-start-9 flex md:justify-end gap-6">
                        <div>
                            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#595959]">
                                {t("video.duration")}
                            </p>
                            <p className="font-display text-2xl flex items-center gap-2 mt-1 text-[#0033A0]">
                                <Clock size={18} strokeWidth={1.25} /> 04:12
                            </p>
                        </div>
                        <div>
                            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#595959]">
                                {t("video.modules")}
                            </p>
                            <p className="font-display text-2xl flex items-center gap-2 mt-1 text-[#0033A0]">
                                <Cpu size={18} strokeWidth={1.25} /> 4
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="max-w-6xl mx-auto px-6 md:px-12 pb-20">
                <div
                    data-testid="video-frame"
                    className="relative aspect-video w-full border border-[#E5EAF2] bg-[#0E1A2B] overflow-hidden shadow-[0_30px_80px_-30px_rgba(0,51,160,0.25)]"
                >
                    <iframe
                        title="SAR-BOT demonstration"
                        src={`https://www.youtube.com/embed/${VIDEO_ID}?rel=0&modestbranding=1`}
                        className="absolute inset-0 w-full h-full"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </div>

                <div className="mt-4 flex items-center justify-between font-mono text-[11px] uppercase tracking-[0.22em] text-[#0033A0]">
                    <span>{t("video.figLeft")}</span>
                    <span className="flex items-center gap-2">
                        <span className="w-1.5 h-1.5 bg-[#FFC72C] rounded-full" />
                        {t("video.figRight")}
                    </span>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-6 md:px-12 pb-24 grid grid-cols-1 md:grid-cols-12 gap-10">
                <div className="md:col-span-5">
                    <p className="font-mono text-xs uppercase tracking-[0.22em] text-[#0033A0] mb-4">
                        {t("video.abstractTag")}
                    </p>
                    <h2 className="font-display text-3xl md:text-4xl leading-tight text-[#0033A0]">
                        {t("video.abstractTitle")}
                    </h2>
                </div>
                <div className="md:col-span-6 md:col-start-7 space-y-5 text-[#445268] leading-relaxed">
                    <p>{t("video.abstractP1")}</p>
                    <p>{t("video.abstractP2")}</p>
                    <div className="pt-4 flex flex-wrap gap-3">
                        <Link
                            to="/gallery"
                            data-testid="video-cta-gallery"
                            className="inline-flex items-center gap-2 bg-[#0033A0] text-white px-6 py-3 text-sm uppercase tracking-[0.18em] hover:bg-[#002277] transition-colors"
                        >
                            <Play size={14} strokeWidth={1.5} />
                            {t("video.ctaGallery")}
                        </Link>
                        <Link
                            to="/"
                            data-testid="video-cta-home"
                            className="inline-flex items-center gap-2 border border-[#0033A0] text-[#0033A0] px-6 py-3 text-sm uppercase tracking-[0.18em] hover:bg-[#0033A0] hover:text-white transition-colors"
                        >
                            {t("video.ctaHome")}
                            <ArrowUpRight size={14} strokeWidth={1.5} />
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Video;
